import React from 'react'
import styled from 'styled-components'

import { ZERO_WIDTH_SPACE } from '../unicodeChars'
import { useStore } from '../zustandStore'

const FlashDiv = (props) => {
  const disableBlinking = useStore(state => (state.publicAppSettings.blinkingAnimations === false))

  if (disableBlinking) {
    return null
  }

  return (
    <StyledFlashDiv>{ZERO_WIDTH_SPACE}</StyledFlashDiv>
  )
}


export default FlashDiv


const StyledFlashDiv = styled.div`
  --color: #aaa;
  --max-opacity: 0.35;

  ${'' /* the parent element of this needs to have position: relative for this to work properly */}
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
  background-color: var(--color);

  opacity: var(--max-opacity);
  @keyframes flash {
    0% { opacity: var(--max-opacity); }
    100% { opacity: 0; }
  }
  animation: flash;
  animation: flash ease-in;
  animation-duration: 1.2s;
  animation-fill-mode: forwards;
`

